/**
 * どのくらい（実施タイミング）— the one list shared by the stylist 設定 screens and
 * the 管理画面 approval sheet. Three values, chips only, never free text.
 */
export const CADENCES = ['新規のお客様ごとに', 'お会計ごとに', '1日1名を目安に'];

export const DEFAULT_CADENCE = CADENCES[2];
